import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import LdsLink from "../../components/LdsLink/index.jsx";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

import AudioPlayer from "../../components/AudioPlayer";
import AudioFile from "../../assets/audio/Amyvid_ISI.mp3";


// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */
  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              Important Safety Information for Amyvid (florbetapir F 18)
            </h1>
            <p className="mt-3"> Estimated time to complete: 2 minutes</p>
          </section>
          <section>
            <AudioPlayer audioSrc={AudioFile} nextUrl={"/module-1/module-1-0-1"}>
              <p>Please <strong>click play on the audio player</strong> to ensure you have reviewed the<br />Important Safety Information <strong>before advancing to the next page</strong>.</p>
            </AudioPlayer>
            <h2 className="h5 b">
              Risk for Image Misinterpretation and Other Errors
            </h2>
            <ul>
              <li>
                Errors may occur in the Amyvid estimation of brain neuritic
                plaque density during image interpretation{" "}
              </li>
              <li>
                Image interpretation should be performed independently of the
                patient’s clinical information. The use of clinical information
                in the interpretation of Amyvid images has not been evaluated
                and may lead to errors. Other errors may be due to extensive
                brain atrophy that limits the ability to distinguish gray and
                white matter on the Amyvid scan, as well as motion artifacts
                that distort the image
              </li>
              <li>
                Amyvid scan results are indicative of the brain neuritic amyloid
                plaque content only at the time of image acquisition and a
                negative scan result does not preclude the development of brain
                amyloid in the future
              </li>
            </ul>
            <h2 className="h5 b mt-4">Radiation Risk</h2>
            <ul>
              <li>
                Amyvid, similar to other radiopharmaceuticals, contributes to a
                patient’s overall long-term cumulative radiation
                exposure. Long-term cumulative radiation exposure is associated
                with an increased risk of cancer. Ensure safe handling to
                protect patients and health care workers from unintentional
                radiation exposure
              </li>
            </ul>
            <p lass="mt-5">The <strong>most common adverse reactions</strong> reported in clinical trials were headache (1.8%), musculoskeletal pain (0.7%), blood pressure increased (0.7%), nausea (0.7%), fatigue (0.5%), and injection site reaction (0.5%).</p>
            <p className="mt-5 mb-3">AM HCP ISI 14SEP2022</p>
            <div className="mt-3">
              <LdsLink
                href="https://pi.lilly.com/us/amyvid-uspi.pdf?s=pi"
                ariaLabel="Please see Full Prescribing Information for Amyvid."
                target="_blank"
                classes="black b"
              >
                Please see Full Prescribing Information for Amyvid.
              </LdsLink>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/indications", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>

            <LdsButton classes="blue-button mt-3 mb-5 align-self-right float-end next" disabled={true} id="next">
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1;
